<template>
    <div class="iconsContent">
        <iconBase @iconsComponent="iconsComponentGetMethod" class="d-none"/>
        <div v-for="(item) in convertIcons" :key="item[0]" class="p-2">
            <div class="item-icon">
                <icon :name="item[0]" />
                {{item[0]}}
            </div>
        </div>
    </div>
</template>
<script>
import iconBase from '@/components/iconBase.vue';
export default {
    data(){
        return{
            iconsComponentGet:''
        }
    },
    components:{
        iconBase,
    },
    computed: {
        convertIcons() {
            let icons = Object.entries(this.iconsComponentGet);
            icons = icons.sort((a, b) => (a[0] > b[0]) ? 1 : -1)
            return icons
        }
    },
    methods:{
        iconsComponentGetMethod(newIconParameter){
            this.iconsComponentGet = newIconParameter;
        }
    }
}
</script>
<style lang="scss">
.iconsContent {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    justify-content: center;
    .item-icon{
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        .svg{
            width: 50px;
            height: 50px;
            margin-bottom: 5px;
        }
    }
}
</style>